// extracted by mini-css-extract-plugin
module.exports = {"table_cell":"Transaction_table_cell__3AJ4j","green":"Transaction_green__3NG24","red":"Transaction_red__7kUcT"};